import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/toaster";

import Draft2Layout from "./draft2/Draft2Layout";
import Draft2Home from "./draft2/Draft2Home";
import AboutPage from "./draft2/pages/AboutPage";
import CourtPage from "./draft2/pages/CourtPage";
import PartnersPage2 from "./draft2/pages/PartnersPage2";
import EventsPage2 from "./draft2/pages/EventsPage2";
import RatesPage2 from "./draft2/pages/RatesPage2";
import AdminPage from "./draft2/pages/AdminPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* Admin dashboard (standalone) */}
          <Route path="/admin" element={<AdminPage />} />

          {/* Main site */}
          <Route element={<Draft2Layout />}>
            <Route path="/" element={<Draft2Home />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/courts/:slug" element={<CourtPage />} />
            <Route path="/partners" element={<PartnersPage2 />} />
            <Route path="/events" element={<EventsPage2 />} />
            <Route path="/rates" element={<RatesPage2 />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
